<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[4]" :innerTitle="navList[4].navChildList[1].name" :innerLink="navList[4].navChildList[1].toLink"></inner-nav>
      <div class="events-content">
        <div class="events-title">
          <h1>霏凡集团发展大事记</h1>
          <h3>2012-2018</h3>
        </div>
        <div class="events-detail">
          <el-carousel :autoplay="false" :interval="4000" type="card" trigger="click" height="3.4rem" indicator-position="none" ref="carousel">
            <el-carousel-item v-for="(item,index) in listDeeds" :key="index" name="index">
              <div class="events-swiper-item">
                <img :src="item.imgUrl" alt="">
                <div>
                  <span v-html="item.content">
                    {{item.content}}
                  </span>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="carousel-arrow">
            <div @click="prevFn(idx)" class="prev">
              <img src="../../../static/img/prev.png" alt="">
            </div>
            <div @click="nextFn(idx)" class="next">
              <img src="../../../static/img/next.png" alt="">
            </div>
          </div>

          <ul class="indicators">
            <li :style="{width:widePercent}" class="indicator" v-for="(item,index) in listDeeds" :key="index" @click="setActiveItem(index)">
              <span :class="{active:index==idx}">{{item.year}}</span>
            </li>
          </ul>

        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  export default {
    name: "",
    data(){
      return {
        idx:0,
        widePercent:'',
        len:0,//轮播图数据的长
        listDeeds:[]
      }
    },
    components: {
      ad,
      InnerNav
    },
    methods:{
      setActiveItem(index){
        this.$refs.carousel.setActiveItem(index);
        this.idx=index;
      },
      prevFn(idx){
        this.$refs.carousel.prev();
        this.idx--;
        if (this.idx<0){
          this.idx=this.len-1;
        }
        console.log(this.idx,'idx',idx)

      },
      nextFn(idx){
        this.$refs.carousel.next();
        this.idx++;
        if (this.idx>=this.len){
          this.idx=0;
        }
        console.log(this.idx,'idx',idx)
      }
    },
    created(){
      //6是数据长度
      this.$http.get(`/outer/development/listDeeds.do`).then((res)=>{
        this.listDeeds=res.data;
        this.len = this.listDeeds.length;
        this.widePercent=parseInt(100/this.len)+'%';
      })

    }
  }
</script>

<style scoped lang="less">
  .events-content{
    padding-bottom: .6rem;
    padding-top:.3rem;
    width:12rem;
      .events-title{
        padding-bottom:1rem;
          h1{
            font-size:.24rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:.48rem;
          }
          h3{
            font-size:.14rem;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:.14rem;
          }
      }


  }



</style>
<style lang="less">
  .events-detail{
    position:relative;
    .el-carousel__arrow--left{
      left:-2rem;
    }
    .el-carousel__arrow--right{
      right: -2rem;
    }
    .el-carousel__item--card{
      width:100%;
    }
    .el-carousel__item, .el-carousel__mask{
      left:-2.8rem;
    }
    .events-swiper-item{
      clear:both;
      img{
        height:3.4rem;
        width:5.6rem;
        float: left;
      }
      div{
        background: #fff;
        width:6.4rem;
        height:3.4rem;
        float: left;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:3.4rem;
        overflow: hidden;
        padding:.5rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        span{
          text-align: justify;
          max-height:2.4rem;
          overflow: hidden;
          margin-top:-1rem;
          font-size:.14rem;
          display: inline-block;
          line-height: .21rem;
          vertical-align: middle;
        }
      }
    }

    .indicators{
      clear: both;
      overflow: hidden;
      margin: 1rem 0;
      width:100%;
      li{
        float: left;
        width:12%;
        text-align: center;
        height:.5rem;
        span{
          cursor: pointer;
          display: inline-block;
          line-height:.4rem;
        }
        .active{
          border-bottom:2px solid red;
          color: red;
        }
      }
    }
    .carousel-arrow{
      z-index: 2;
      overflow: hidden;
      height:3.4rem;
      width:14.4rem;
      position: absolute;
      top:0;
      left:-1.2rem;
      div{
        opacity:0;
        position: absolute;
        top:1.35rem;
        border:1px solid #999999;
        -webkit-border-radius:50%;
        -moz-border-radius:50%;
        border-radius:50%;;
        line-height:.7rem;
        text-align: center;
        width:.7rem;
        height:.7rem;
        img{
          vertical-align: middle;
          width:.5rem;
          height:.5rem;
        }
      }
      .prev{
        left:.6rem;
        transition: left 1s ease;
      }
      .next{
        right:.6rem;
        transition: right 1s ease;

      }
    }
    .carousel-arrow:hover{
      .prev{
        opacity: 1;
        left:0rem;
      }
      .next{
        opacity: 1;
        right:0rem;
      }
    }

  }


</style>



// WEBPACK FOOTER //
// src/pages/development/events.vue